// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-SideContent-styles--root--aRALi {
  box-sizing: border-box;
  border-top: 10px solid #f3f4f7;
}

@media screen and (min-width: 768px) {

.src-components-SideContent-styles--root--aRALi {
    border-top: 1px solid #e8eaf0;
    border-top: 1px solid var(--lightGrayBlue);
    padding-top: 20px;
    padding-bottom: 20px;
}
  }

@media screen and (min-width: 1024px) {

.src-components-SideContent-styles--root--aRALi {
    border: 0;
    padding: 25px;
    width: 260px;
}
  }

@media screen and (min-width: 1280px) {

.src-components-SideContent-styles--root--aRALi {
    width: 325px;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/SideContent/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,sBAAsB;EACtB,8BAA8B;AAiBhC;;AAfE;;AAJF;IAKI,6BAA0C;IAA1C,0CAA0C;IAC1C,iBAAiB;IACjB,oBAAoB;AAYxB;EAXE;;AAEA;;AAVF;IAWI,SAAS;IACT,aAAa;IACb,YAAY;AAMhB;EALE;;AAEA;;AAhBF;IAiBI,YAAY;AAEhB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  box-sizing: border-box;\n  border-top: 10px solid #f3f4f7;\n\n  @media (--desktop) {\n    border-top: 1px solid var(--lightGrayBlue);\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n\n  @media (--desktop-l) {\n    border: 0;\n    padding: 25px;\n    width: 260px;\n  }\n\n  @media (--desktop-x) {\n    width: 325px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-SideContent-styles--root--aRALi`
};
module.exports = ___CSS_LOADER_EXPORT___;
